import React from 'react';
import { firestore } from '../contexts/FirebaseContext';

const formatItemToHistorial = (data) => {
  const obj = {
    idProducto: data.productoId,
    name: data.productoName,
    cantidad: data.cantidad,
    price_unit: data.product_price_venta,
    price_complete: data.product_price_venta * data.cantidad
  };

  return obj;
};

const traspasoIdAndExistencia = (existenciaActualTraspaso) => {};

function useEmpaque() {
  const inicializarAlmacen = async (userId) => {
    const userInfo = await (await firestore.collection('users').doc(userId).get()).data();
    const newAlmacen = await firestore.collection('emp_almacenes').add({
      userId,
      userName: userInfo.displayName,
      email: userInfo.email,
      status: 'active',
      productoItems: [],
      created_date: new Date(),
      updated_date: new Date()
    });

    const res = await firestore.collection('users').doc(userId).update({ almacenId: newAlmacen.id });

    return res;
  };

  const inicializarAlmacenGeneral = async () => {
    const res = await firestore.collection('emp_almacenes').doc('CEDIS').set({
      id: 'CEDIS',
      userId: 'CEDIS',
      userName: 'CEDIS - Almacen general',
      email: '',
      status: 'active',
      productoItems: [],
      created_date: new Date(),
      updated_date: new Date()
    });

    return res;
  };

  // eslint-disable-next-line consistent-return
  const handleMovimientosEmpaqueAlmacen = async (productList, alamacenId, alamacenData, action, extraData) => {
    // const almacenData = (await firestore.collection('emp_almacenes').doc(alamacenId).get()).data();
    const { productoItems } = alamacenData;

    if (action === 'SUBSTRACT') {
      const res = await Promise.all(
        // eslint-disable-next-line consistent-return
        productList.map(async (item) => {
          const findedProduct = productoItems.find((it) => it.id === item.idProducto);

          if (findedProduct) {
            const obj = {
              almacendId: alamacenId,
              idProducto: item.idProducto,
              productoName: item.name,
              cantidad: item.cantidad,
              price_unit: item.price_unit,
              price_complete: item.price_complete,
              cantAnterior: findedProduct.existencia,
              cantResultante: findedProduct.existencia - item.cantidad,
              ...extraData,
              type: 'SUBSTRACT',
              createdAt: new Date(),
              updatedAt: new Date()
            };

            // eslint-disable-next-line no-return-await
            return await firestore.collection('empaque_historial').add(obj);
          }
          // if (!findedProduct) {
          //   const obj = {
          //     almacendId: alamacenId,
          //     idProducto: item.idProducto,
          //     productoName: item.name,
          //     cantidad: item.cantidad,
          //     price_unit: item.price_unit,
          //     price_complete: item.price_complete,
          //     cantAnterior: findedProduct.existencia,
          //     cantResultante: findedProduct.existencia - item.cantidad,
          //     ...extraData,
          //     createdAt: new Date(),
          //     updatedAt: new Date()
          //   };

          //   // eslint-disable-next-line no-return-await
          //   return await firestore.collection('empaque_historial').add(obj);
          // }
        })
      );

      return res;
    }
    if (action === 'ADD') {
      const res = await Promise.all(
        // eslint-disable-next-line consistent-return
        productList.map(async (item) => {
          const findedProduct = productoItems.find((it) => it.id === item.idProducto);

          if (findedProduct) {
            const obj = {
              almacendId: alamacenId,
              idProducto: item.idProducto,
              productoName: item.name,
              cantidad: item.cantidad,
              price_unit: item.price_unit,
              price_complete: item.price_complete,
              cantAnterior: findedProduct.existencia,
              cantResultante: findedProduct.existencia + item.cantidad,
              ...extraData,
              type: 'ADD',
              createdAt: new Date(),
              updatedAt: new Date()
            };

            // eslint-disable-next-line no-return-await
            return await firestore.collection('empaque_historial').add(obj);
          }
          if (!findedProduct) {
            const obj = {
              almacendId: alamacenId,
              idProducto: item.idProducto,
              productoName: item.name,
              cantidad: item.cantidad,
              price_unit: item.price_unit,
              price_complete: item.price_complete,
              cantAnterior: 0,
              cantResultante: item.cantidad,
              ...extraData,
              type: 'ADD',
              createdAt: new Date(),
              updatedAt: new Date()
            };

            // eslint-disable-next-line no-return-await
            return await firestore.collection('empaque_historial').add(obj);
          }
        })
      );

      return res;
    }
  };

  // eslint-disable-next-line consistent-return
  const regTraspasoProducto = async (objectData) => {
    const { origen, destino, item, status, idTraspasoItem } = objectData;

    if (status === 'PENDIENTE') {
      const res = await firestore.collection('emp_traspasos').add({
        origenUser: origen.userName,
        origenUserId: origen.userId,
        origenId: origen.id,
        destinoUser: destino.userName,
        destinoUserId: destino.userId,
        destinoId: destino.id,
        productoId: item.id,
        productoName: item.name,
        productoImg: item.img,
        productoDescription: item.description,
        product_price_compra: item.price_compra,
        product_price_venta: item.price_venta,
        productType: item.type,
        product_unidad_medida: item.unidad_medida,
        productVariant: item.variant,
        cantidad: item.cantidad,
        status: 'PENDIENTE',
        created_at: new Date(),
        updated_at: new Date()
      });

      return res;
    }
    if (status === 'ACEPTADO' && idTraspasoItem) {
      const res = await firestore
        .collection('emp_traspasos')
        .doc(idTraspasoItem)
        .update({ status: 'ACEPTADO', updated_at: new Date() });

      return res;
    }
    if (status === 'COMPRA') {
      const res = await firestore.collection('emp_traspasos').add({
        origenUser: 'COMPRA',
        origenUserId: 'COMPRA',
        origenId: 'COMPRA',
        destinoUser: destino.userName,
        destinoUserId: destino.userId,
        destinoId: destino.id,
        productoId: item.id,
        productoName: item.name,
        productoImg: item.img,
        productoDescription: item.description,
        productType: item.type,
        product_unidad_medida: item.unidad_medida,
        productVariant: item.variant,
        cantidad: item.cantidad,
        status: 'COMPRA',
        costoUnit: item.costoUnit,
        costo: Number(item.costoUnit) * Number(item.cantidad),
        created_at: new Date(),
        updated_at: new Date()
      });

      return res;
    }
    if (status === 'CANCELADO') {
      const res = await firestore
        .collection('emp_traspasos')
        .doc(idTraspasoItem)
        .update({ status: 'CANCELADO', updated_at: new Date() });

      return res;
    }
  };

  const enviarProducto = async (idOrigen, idDestino, items) => {
    const almacenOrigen = await (await firestore.collection('emp_almacenes').doc(idOrigen).get()).data();
    const almacenDestino = await (await firestore.collection('emp_almacenes').doc(idDestino).get()).data();

    let almOriginItems = [...almacenOrigen.productoItems];

    // eslint-disable-next-line no-restricted-syntax
    for (const item of items) {
      const finded = almOriginItems.find((it) => it.id === item.id);

      // if (finded) {
      const obj = {
        ...finded,
        existencia: Number(finded.existencia) - Number(item.cantidad)
      };
      const filtered = almOriginItems.filter((it) => it.id !== item.id);
      almOriginItems = [...filtered, obj];
      // } else {
      //   break;
      // }
    }

    // lista de ids de los traspasos
    const traspasosIdArr = [];

    await Promise.all(
      items.map(async (item) => {
        const objReg = {
          origen: { id: idOrigen, ...almacenOrigen },
          destino: { id: idDestino, ...almacenDestino },
          item,
          status: 'PENDIENTE'
        };
        const res = await regTraspasoProducto(objReg);
        traspasosIdArr.push(res.id);
      })
    );

    const solTraspasoObj = {
      traspasosIds: traspasosIdArr,
      almacenOrigenId: idOrigen,
      origenUser: almacenOrigen.userName,
      origenUserId: almacenOrigen.userId,

      almacenDestinoId: idDestino,
      destinoUser: almacenDestino.userName,
      destinoUserId: almacenDestino.userId,
      status: 'PENDIENTE',
      created_at: new Date(),
      updated_at: new Date()
    };

    await firestore.collection('emp_solicitudTraspaso').add(solTraspasoObj);

    const res = await firestore.collection('emp_almacenes').doc(idOrigen).update({ productoItems: almOriginItems });
    return res;
  };

  // traspasoItem es el registro de un producto en coleccion emp_traspasos
  const recepcionarProductos = async (idOrigen, idDestino, traspasoItem) => {
    // const almacenOrigen = await (await firestore.collection('emp_almacenes').doc(idOrigen).get()).data();
    const almacenDestino = await (await firestore.collection('emp_almacenes').doc(idDestino).get()).data();

    let almDestinoItems = [...almacenDestino.productoItems];

    const finded = almDestinoItems.find((it) => it.id === traspasoItem.productoId);

    if (finded) {
      const obj = {
        ...finded,
        existencia: Number(finded.existencia) + Number(traspasoItem.cantidad),
        price_compra: Number(traspasoItem.product_price_compra),
        price_venta: Number(traspasoItem.product_price_venta)
        // para ver los datos del traspaso actual
        // actualTraspasoId: finded?.actualTraspasoId ? finded.actualTraspasoId : traspasoItem.id,
        // existenciaTraspaso: finded?.existenciaTraspaso ? finded?.existenciaTraspaso : Number(traspasoItem.cantidad)
      };
      const filtered = almDestinoItems.filter((it) => it.id !== obj.id);
      almDestinoItems = [...filtered, obj];
    } else {
      const obj = {
        id: traspasoItem.productoId,
        name: traspasoItem.productoName,
        img: traspasoItem.productoImg,
        description: traspasoItem.productoDescription,
        type: traspasoItem.productType,
        unidad_medida: traspasoItem.product_unidad_medida,
        variant: traspasoItem.productVariant,
        price_compra: Number(traspasoItem.product_price_compra),
        price_venta: Number(traspasoItem.product_price_venta),
        minStock: 10,
        maxStock: 100,
        existencia: Number(traspasoItem.cantidad)
        // para ver los datos del traspaso actual
        // actualTraspasoId: traspasoItem.id,
        // existenciaTraspaso: Number(traspasoItem.cantidad)
      };

      almDestinoItems.push(obj);
    }

    const objReg = {
      idTraspasoItem: traspasoItem.id,
      status: 'ACEPTADO'
    };

    await regTraspasoProducto(objReg);
    await firestore.collection('emp_almacenes').doc(idDestino).update({ productoItems: almDestinoItems });

    // await firestore.collection('emp_regTraspasos').add({
    //   productId: traspasoItem.productoId,
    //   alamacenId: idDestino,
    //   traspasoId: traspasoItem.id,
    //   traspasoCantidad: Number(traspasoItem.cantidad),
    //   cantidadActual: Number(traspasoItem.cantidad),
    //   type: traspasoItem.productType,
    //   unidad_medida: traspasoItem.product_unidad_medida,
    //   price_compra: Number(traspasoItem.product_price_compra),
    //   price_venta: Number(traspasoItem.product_price_venta)
    // });

    await handleMovimientosEmpaqueAlmacen([formatItemToHistorial(traspasoItem)], idDestino, almacenDestino, 'ADD');
    const res = firestore.collection('emp_historialRecepciones').add({
      idAmacen: idDestino,
      cantidad: traspasoItem.cantidad,
      product_price_compra: traspasoItem.product_price_compra,
      product_price_venta: traspasoItem.product_price_venta,
      productoId: traspasoItem.productoId,
      createdAt: new Date(),
      updatedAt: new Date()
    });
    return res;
  };

  const recepcionarProdAlmacenGeneral = async (idDestino, item) => {
    const almacenDestino = await (await firestore.collection('emp_almacenes').doc(idDestino).get()).data();

    let almDestinoItems = [...almacenDestino.productoItems];

    const finded = almDestinoItems.find((it) => it.id === item.id);

    if (finded) {
      const obj = {
        ...finded,
        existencia: Number(finded.existencia) + Number(item.cantidad),
        costoUnit: Number(item.costoUnit)
      };
      const filtered = almDestinoItems.filter((it) => it.id !== obj.id);
      almDestinoItems = [...filtered, obj];
    } else {
      const obj = {
        id: item.id,
        name: item.name,
        img: item.img,
        description: item.description,
        type: item.type,
        unidad_medida: item.unidad_medida,
        variant: item.variant,
        minStock: 10,
        maxStock: 100,
        existencia: Number(item.cantidad),
        costoUnit: Number(item.costoUnit)
      };

      almDestinoItems.push(obj);
    }

    const objReg = {
      destino: { id: idDestino, ...almacenDestino },
      status: 'COMPRA',
      item
    };

    await regTraspasoProducto(objReg);
    const res = await firestore.collection('emp_almacenes').doc(idDestino).update({ productoItems: almDestinoItems });
    return res;
  };

  const cancelarEnvioProducto = async (idOrigen, idDestino, traspasoItem) => {
    const almacenOrigen = await (await firestore.collection('emp_almacenes').doc(idOrigen).get()).data();

    let almOrigenItems = [...almacenOrigen.productoItems];

    const finded = almOrigenItems.find((it) => it.id === traspasoItem.productoId);

    if (finded) {
      const obj = {
        ...finded,
        existencia: Number(finded.existencia) + Number(traspasoItem.cantidad)
      };

      const filtered = almOrigenItems.filter((it) => it.id !== obj.id);
      almOrigenItems = [...filtered, obj];
    }

    const objReg = {
      idTraspasoItem: traspasoItem.id,
      status: 'CANCELADO'
    };

    await regTraspasoProducto(objReg);
    const res = await firestore.collection('emp_almacenes').doc(idOrigen).update({ productoItems: almOrigenItems });
    return res;
  };

  return {
    inicializarAlmacen,
    inicializarAlmacenGeneral,
    enviarProducto,
    recepcionarProductos,
    recepcionarProdAlmacenGeneral,
    cancelarEnvioProducto,
    handleMovimientosEmpaqueAlmacen
  };
}

export default useEmpaque;
